import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/loading_new.png'


const _hoisted_1 = { class: "wrong-question-list-con" }
const _hoisted_2 = {
  class: "date-box",
  id: "dateBox"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "total-num" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "question-bottom" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "loading"
}
const _hoisted_7 = {
  key: 1,
  class: "new-loading wrong-question-loading"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "new-loading-con" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", null, "加载中…")
], -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_detail = _resolveComponent("question-detail")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_no_data = _resolveComponent("no-data")!
  const _component_rocket = _resolveComponent("rocket")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateObj, (dateItem, dateIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["date-item", {'date-cur': _ctx.date == dateIndex}]),
          key: dateIndex,
          onClick: ($event: any) => (_ctx.chooseDate(dateIndex))
        }, _toDisplayString(dateItem), 11, _hoisted_3))
      }), 128))
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.questionData.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_4, "共" + _toDisplayString(_ctx.totalNum) + "道错题", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionData, (question, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "question-item",
                    key: index
                  }, [
                    _createVNode(_component_question_detail, {
                      showKnowledgePoint: true,
                      questionIndex: index+1,
                      isList: true,
                      onClick: ($event: any) => (_ctx.linkDetails(question)),
                      questionData: question
                    }, null, 8, ["questionIndex", "onClick", "questionData"]),
                    _hoisted_5
                  ]))
                }), 128)),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_van_loading, { size: "24px" }, {
                        default: _withCtx(() => [
                          _createTextVNode("加载中...")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.hasAjaxData && _ctx.questionData.length === 0)
            ? (_openBlock(), _createBlock(_component_no_data, {
                key: 1,
                isWrongQuestion: true
              }))
            : _createCommentVNode("", true),
          (_ctx.isShowRocket)
            ? (_openBlock(), _createBlock(_component_rocket, {
                key: 2,
                onClick: _ctx.goTop
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
  ]))
}